import React from 'react'
import {
  Grid,
  Box,
  Button
} from "@material-ui/core"
import { ideaEditStyles } from './IdeaEditStyles'
import Info from '@material-ui/icons/Info';
import DescriptionIcon from '@material-ui/icons/Description';
import { EditUpload, EditUploadButton } from './../../components/Upload';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import dialogFileSvg from '../../assets/imgs/dialog-file.svg';

export const IdeaEditGeneralDocs = () => {
  const classes = ideaEditStyles();

  return (
    <Grid item xs={12}>
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={12} className={classes.header}>
          <Box display='flex' alignItems='center'>
            <Box className={classes.iconHeader}>
              <DescriptionIcon color="primary" />
            </Box>
            <Box className={classes.titleCard}>documentos</Box>
          </Box>
          <EditUploadButton 
            type="file"
            variant="text"
            text={"adicionar documento"}
            icon={<AddCircleOutlinedIcon />}
          />
        </Grid>
        <Grid item xs={12}>
          <EditUpload
            type="file"
            img={dialogFileSvg}
            name="arquivo"
            message=""
            accept=".pdf,application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.doc,application/msword,.ppt,application/vnd.ms-powerpoint,.pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation"
            maxSize={26214400}
          />
          <Box className={classes.info}>
            <Info style={{fontSize: 15, marginRight: 7 }}/>
            <p>
              O arquivo deve ser em formato <strong> png</strong> e<strong> jpg </strong> 
              e possuir tamanho máximo de<strong> 5mb</strong>.
            </p>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}
